module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/pets-view/mypets"
    }
  }, [_c('a', [_vm._v("My Pets")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "active-class": "active",
      "tag": "li",
      "to": "/pets-view/addpet"
    }
  }, [_c('a', [_vm._v("Add Pet")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-center hidden-xs"
  }, [_c('i', {
    staticClass: "fa fa-paw "
  }), _vm._v(" Manage your Pets info")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text-center hidden-sm hidden-md hidden-lg"
  }, [_c('i', {
    staticClass: "fa fa-paw "
  }), _vm._v(" Manage your Pets info")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0c2a3e52!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PetRegistration/PetsView.vue
// module id = 604
// module chunks = 2